import { TextHelpBooks } from '../Help/HelpEsBooks'
import CardHelp from './CardHelp'

export const HelpBooksOptions = () => {
    return (
      <>
          {
              TextHelpBooks.map((hlp, idx) => (
                  <CardHelp
                      key={idx}
                      title={hlp.title}
                      text={hlp.text}
                  ></CardHelp>
              ))
          }
      </>
    )
}